export default __webpack_public_path__ + "static/media/harness_of_vicious_frenzy.57da2b60.jpg";